import { render, staticRenderFns } from "./quotes-block.vue?vue&type=template&id=45f4fa85&scoped=true"
var script = {}
import style0 from "./quotes-block.vue?vue&type=style&index=0&id=45f4fa85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4fa85",
  null
  
)

export default component.exports